const LOG_LEVELS = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
} as const;

// Set to DEBUG in development
const currentLevel = process.env.NODE_ENV === 'development' ? LOG_LEVELS.DEBUG : LOG_LEVELS.INFO;

export const logger = {
  debug: (...args: any[]) => {
    if (currentLevel <= LOG_LEVELS.DEBUG) {
      console.debug(new Date().toISOString(), '[DEBUG]', ...args);
    }
  },
  
  info: (...args: any[]) => {
    if (currentLevel <= LOG_LEVELS.INFO) {
      console.info(new Date().toISOString(), '[INFO]', ...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (currentLevel <= LOG_LEVELS.WARN) {
      console.warn(new Date().toISOString(), '[WARN]', ...args);
    }
  },
  
  error: (...args: any[]) => {
    if (currentLevel <= LOG_LEVELS.ERROR) {
      console.error(new Date().toISOString(), '[ERROR]', ...args);
    }
  }
};